import { Table } from 'antd';
import React from 'react';

// Port NGUYÊN VĂN từ license-cms/source/src/compoments/common/table/BaseTable.js (14 dòng).
//
// ⚠️ KHÔNG dùng BaseTable của @itz: nó mặc định `scroll={{ x: 'max-content' }}` khiến cột co lại
// theo nội dung (cột Note trống bị bóp hẹp) và bảng tràn ngang sinh thanh cuộn — bản cũ dùng
// `scroll={{ x: true }}`.
// Ba mặc định của nguồn đều là hành vi quan sát được, giữ đủ:
//   · className="base-table"  · size="middle"  · scroll={{ x: true }}
//   · pagination: luôn ép showSizeChanger=false và hideOnSinglePage=true; không truyền -> ẩn hẳn
const BaseTable = (props) => (
    <Table
        className="base-table"
        size="middle"
        scroll={{ x: true }}
        {...props}
        pagination={props.pagination ? { ...props.pagination, showSizeChanger: false, hideOnSinglePage: true } : false}
    />
);

export default BaseTable;
